export default {
      id: "common__chevron_left_double-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__chevron_left_double",
      toString: function () {
        return this.url;
      }
    }